import { AccruedInterestActionsContext, useCreateAccruedInterestActionsContext } from './AccruedInterestActions.context'
import { BalanceCorrectionDialog } from './dialogs/BalanceCorrectionDialog'
import { ConfirmBalancesDialog } from './dialogs/ConfirmBalancesDialog'
import { DailyCorrectionDialog } from './dialogs/DailyCorrectionDialog'
import { DiscardDraftsDialog } from './dialogs/DiscardDraftsDialog'

export const AccruedInterestActionsProvider = ({ children }: React.PropsWithChildren) => {
  const context = useCreateAccruedInterestActionsContext()
  const state = context.actionState
  return (
    <AccruedInterestActionsContext.Provider value={context}>
      {children}
      {state?.type === 'daily' && (
        <DailyCorrectionDialog key={state.params.row.trade_id} {...state.params} onClose={context.close} />
      )}
      {state?.type === 'balance' && (
        <BalanceCorrectionDialog key={state.params.row.trade_id} {...state.params} onClose={context.close} />
      )}
      {state?.type === 'confirm' && <ConfirmBalancesDialog {...state.params} onClose={context.close} />}
      {state?.type === 'discard' && <DiscardDraftsDialog {...state.params} onClose={context.close} />}
    </AccruedInterestActionsContext.Provider>
  )
}
